import { create } from "zustand"
import StudentsService from "../API/StudentsService"
import { toISODate } from "../utils/globalHelper"

const _date = new Date()
const filter_start_date = new Date(_date.getFullYear(), _date.getMonth(), 1)
const filter_end_date = new Date(_date.getFullYear(), _date.getMonth(), 14)

export const useStudentsStore = create((set, get) => ({
    students: [],
    setStudents: (_students) => set({ students: _students }),
    updateStudent: (updatedStudent) => set(state => ({
        students: state.students.map(student => student.site_id === updatedStudent.site_id ? updatedStudent : student)
    })),
    updateStudentCommType: (id, type) => set(state => ({
        students: state.students.map((s) => {
            if (s.site_id === id)
                s.communication_type = type
            return s
        })
    })),

    searchFilters: {
        string: '',
        start_goal: 0,
        end_goal: 100,
        subjects: [],
    },
    setSearchFilters: (newSearchFilters) => set({ searchFilters: newSearchFilters }),

    studentsLoading: false,
    setStudentsLoading: (isLoading) => set({ studentsLoading: isLoading }),

    studentsDumpLoading: false,
    setStudentsDumpLoading: (isLoading) => set({ studentsDumpLoading: isLoading }),

    purchaseTags: [],
    setPurchaseTags: (newTags) => set({ purchaseTags: newTags }),
    fetchPurchaseTags: async () => {
        if (get().purchaseTags.length < 1) {
            const response = await StudentsService.getPurchaseTags()
            if (response?.status === 200) {
                set({ purchaseTags: response.data })
            }
        }
    },

    communicationTypes: [],
    fetchCommunicationTypes: async () => {
        if (get().communicationTypes.length < 1) {
            const response = await StudentsService.getCommunicationTypes()
            if (response?.status === 200)
                set({ communicationTypes: response.data })
        }
    },

    onboardingStatuses: [],
    fetchOnboardingStatuses: async () => {
        if (get().onboardingStatuses.length < 1) {
            const response = await StudentsService.getOnboardingStatuses()
            if (response?.status === 200)
                set({ onboardingStatuses: response.data })
        }
    },
}))

export const useStudentsFilters = create((set, get) => ({
    filters: {
        month: toISODate(filter_start_date).substring(0, 7),
        filter_start_date: toISODate(filter_start_date),
        filter_end_date: toISODate(filter_end_date),
        potok12: true,
        potok3: false,
        filter_syscoursetype_ids: [22, 25, 27, 31,],
    },
    setFilters: (newFilters) => set({ filters: newFilters }),
}))
